// extracted by mini-css-extract-plugin
export default {"root":"_3x7hT","link-overlay":"_2YMlK","linkOverlay":"_2YMlK"};